/*
 * @Author: weijinpeng jinpeng.wei@ctx.sg
 * @LastEditors: weijinpeng jinpeng.wei@ctx.sg
 * @Date: 2023-03-07 16:37:27
 * @LastEditTime: 2023-03-08 16:01:08
 * @Description: 
 */
import http from '@/api/http'

export default {
    getretirementList(cb, form) {
        http.post('/api/carbonCredit/retirement/page', cb, form)
    },
    getretirementFrom(cb, form) {
        http.post('/api/carbonCredit/retirement/request/confirm', cb, form)
    },
    geretirementdetail(cb, request) {
        http.get('/api/carbonCredit/retirement/detail', cb, request)
    },
    getTransferList(cb, form) {
        http.post('/api/carbonCredit/transfer/page', cb, form)
    },
    getTransferconfirm(cb, form) {
        http.post('/api/carbonCredit/transfer/request/confirm', cb, form)
    },
    getTransferdetail(cb, form) {
        http.get('/api/carbonCredit/transfer/detail', cb, form)
    },
    // 获取用户列表
    getlistByCondition(cb, form) {
        http.post('/api/user/listByCondition', cb, form)
    },
    // 创建或更新一个新用户
    getcreateOrUpdate(cb, form) {
        http.post('/api/user/createOrUpdate', cb, form)
    },
    // 修改用户状态
    getuserstatus(cb, form) {
        http.get('/api/user/status/convert', cb, form)
    },
    // 根据id删除用户
    getuserdelete(cb, form) {
        http.get('/api/user/delete', cb, form)
    },
    // 根据id获取用户信息
    getuserinfo(cb, form) {
        http.get('/api/user/info', cb, form)
    },
    // 审批流程管理列表
    getlistByapproveProcess(cb, form) {
        http.post('/api/approveProcess/listByCondition', cb, form)
    },
    // 编辑审批流程管理
    getapproveProcess(cb, form) {
        http.post('/api/approveProcess/update', cb, form)
    },
    // 根据id获取审批流程
    getapproveProcessinfo(cb, form) {
        http.get('/api/approveProcess/info', cb, form)
    },

}